import { render, staticRenderFns } from "./ReportSolutionAlertList.vue?vue&type=template&id=6de15268&"
import script from "./ReportSolutionAlertList.vue?vue&type=script&lang=js&"
export * from "./ReportSolutionAlertList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/solutions.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports